export interface TypeDocumentsSelectProps {
  label: string;
  value: string;
  realName?: string;
  legalDocumentType: number;
}

export interface DataFileStateProps {
  file: File | undefined;
}

export const FileTypesAccept = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/tiff',
  'image/bmp'
];

export const DocumentDefault = {
  typeDocument: "",
  nameDocument: "",
};

export interface TypeDocumentProps {
  realName: string;
  valueName: string;
  legalDocumentType: number;
}

export const typeDocuments: TypeDocumentsSelectProps[] = [
  {
    'realName': "Alvará Sanitário",
    'label': "Alvará",
    'value': "alvara",
    'legalDocumentType': 0
  },
  {
    'realName': "Certificação de Responsabilidade Técnica",
    'label': "CRT",
    'value': "crt",
    'legalDocumentType': 1
  },
  {
    'realName': "Outros",
    'label': "Outros",
    'value': "outros",
    'legalDocumentType': 2
  }
];

export enum EnumTypeDocument {
  ALVARA = "alvara",
  CRT = "crt",
  OUTROS = "outros"
}

export const allTypeDocument = ["alvara", "crt", "outros"];
